<template>
  <div class="col-4" @click="biggerImage()">
    <div class="col-12 mask-container" v-bind:class="{soldout: maskElement.soldOut}">
        <div class="row item-header">
          <div class="col-7-sm col-12 tight">
            <span class="col-12 mask-name">{{maskElement.name}}</span>
          </div>
          <div class="col-5-sm col-12 tight" v-if="totalAvailable > 0">
            <span class="col-12 mask-available">{{totalAvailable}} available</span>
          </div>
          <div class="col-5-sm col-12 tight" v-else>
            <span class="col-12 mask-available soldout">out of stock</span>
          </div>
        </div>
        <div class="row">
        <figure v-lazyload class="loading"
        :style="{ background: 'url(' + require('@/assets/oro-spinner.gif') + ') no-repeat 50% #FFF' }">
            <div class="col-12 image-wrapper"
              :data-url="maskElement.thumbURL"
            >
              <div class="action-container">
                <div class="reserve" v-if="!user.uid && totalAvailable > 0" v-on:click.stop="openModal(maskElement)">reserve</div>
                <div class="reserve" v-if="user.uid" v-on:click.stop="goToEdit()">edit</div>
              </div>
            </div>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from '../mixins/HelperFunctions.js'
export default {
  mixins: [Mixin],
  name: 'maskElement',
  props: {
    maskElement: Object
  },
  created() {},
  data: function (){
    return {
      spinner: "./assets/oro-spinner.gif"
    }
  },
  computed: {
    totalAvailable() {
      return this.maskElement.available - (this.maskElement.pending ? this.maskElement.pending : 0)
    }
  },
  methods: {
    biggerImage() {
      this.$store.commit('setImageModal', {...this.maskElement})
    },
    openModal() {
      this.$store.commit('setModal', this.maskElement)
    },
    goToEdit () {
      this.$router.push({name: 'editmask', params: {id: this.maskElement.id}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.tight {
  margin-top: 0;
  margin-bottom: 0;
}
figure {
  margin: 0;
  width: 100%;
}
figure.loading {
  height: 200px;
}
.image-wrapper {
  height: 200px;
  width: 100%;
    margin: 0;
  position: relative;
  .action-container {
    position: relative;
    width: 100%;
    top: 140px;
    background: none;
    .reserve {
      text-shadow: 2px 2px 2px white;
      cursor: pointer;
      background: rgba(255,255,255,.8);
      border: 1px solid white;
      color: gray;
      display: inline-block;
      padding: 5px;
      border-radius: 5px;
      font-weight: bold;
      margin: 10px;
      width: 80px;
      position: absolute;
      right: 0;
      -webkit-transition: background 0.5s;
      &:hover {
        background: rgba(255,255,255,1);
        -webkit-transition: background 0.5s;
      }
    }
  }
}

.mask-container {
  background: white;
  box-shadow: 0 8px 6px -6px black;
  border: 2px solid white;
  border-radius: 5px;
  height: 240px;
  overflow: hidden;
  cursor: zoom-in;

  &.soldout {
    border: 2px solid black;
    .item-header, .mask-name, .mask-available {
      background: black;
      .mask-name, .mask-available {
        background: black;
        color: white;
        &.soldout {
          color: white;
        }
      }
    }
  }
  .item-header {
    // padding: 10px 5px;
    font-weight: bold;
    color: #264653;
    width: 100%;
    margin: 0;
    background: white;
    height: 50px;
    .mask-name {
      background: white;
      color: $oroGray;
      margin: 0;
      width: 100%;
    }
    .mask-available {
      width: 100%;
      margin: 0;
      background: white;
      font-weight: normal;
      color: gray;
      // float: right;
      &.soldout {
        color: $oroGray;
        border-radius: 4px;
        font-weight: bold;
      }
    }
  }
}

@media only screen and (max-width: $breakpoint-med) {
  .col-5-sm.tight, .col-7-sm.tight {

    span {
      padding: 10px 0;
    }
    .mask-name {
      text-align: left;
      padding-left: 10px;
    }
    .mask-available {
      text-align: right;
      &.soldout {
        text-align: center;
        height: 22px;
        margin-top: 3px;
      }
    }
  }
}
</style>
